import React from 'react'
import { Box, type BoxProps } from '@mantine/core'
import { MAIN_CONTENT_HORIZONTAL_GUTTER_PX } from './mainContentHorizontalGutter'

export type MainContentInsetProps = BoxProps

/**
 * Horizontal inset inside the app shell main column (16px). Use when a single route
 * needs side padding but should not opt the whole pathname into shell-level gutter.
 */
export default function MainContentInset ({ sx, ...props }: MainContentInsetProps) {
  return (
    <Box
      sx={{
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
        paddingLeft: MAIN_CONTENT_HORIZONTAL_GUTTER_PX,
        paddingRight: MAIN_CONTENT_HORIZONTAL_GUTTER_PX,
        ...sx
      }}
      {...props}
    />
  )
}
